"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateApiResponse = exports.validateErrorResponse = exports.validateSuccessResponse = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const validation_1 = require("@fmtk/validation");
function validateSuccessResponse(result = (0, validation_1.any)()) {
    return (0, validation_1.properties)({
        result,
        ok: (0, validation_1.is)(true),
        status: (0, validation_1.integer)(),
    });
}
exports.validateSuccessResponse = validateSuccessResponse;
function validateErrorResponse() {
    return (0, validation_1.properties)({
        error: (0, validation_1.text)(),
        errorDetails: (0, validation_1.optional)((0, validation_1.any)()),
        ok: (0, validation_1.is)(false),
        status: (0, validation_1.integer)(),
    });
}
exports.validateErrorResponse = validateErrorResponse;
function validateApiResponse(result = (0, validation_1.any)()) {
    return (0, validation_1.or)(validateSuccessResponse(result), validateErrorResponse());
}
exports.validateApiResponse = validateApiResponse;
//# sourceMappingURL=ApiResponse.js.map